import type { FC, ReactNode } from "react";

import { MetricCard } from "../common/MetricCard";
import { Text } from "../common/Text";

interface SummaryCardProps {
  title: string;
  value: number;
  description: string;
  icon?: ReactNode;
  trend?: { value: number; isPositive: boolean };
}

export const SummaryCard: FC<SummaryCardProps> = ({
  title,
  value,
  description,
  icon,
  trend,
}) => (
  <MetricCard
    className="!border-slate-300 !bg-white transition-colors hover:!border-slate-400 dark:!border-slate-700 dark:!bg-arti-panel"
    label={title}
    value={
      <div className="space-y-1">
        <div className="flex items-start justify-between">
          <div className="mt-1 text-xl font-bold text-gray-900 dark:text-white">
            {value.toLocaleString()}
          </div>
          {icon && (
            <div className="rounded-none border border-slate-300 bg-slate-50 p-2 text-gray-600 dark:border-slate-700 dark:bg-arti-background dark:text-gray-400">
              {icon}
            </div>
          )}
        </div>
        <Text as="div">{description}</Text>
        {trend && (
          <div
            className={`text-xs font-semibold ${trend.isPositive ? "text-emerald-600 dark:text-emerald-400" : "text-rose-600 dark:text-rose-400"}`}
          >
            {trend.isPositive ? "Up" : "Down"} {Math.abs(trend.value)}%
          </div>
        )}
      </div>
    }
  />
);
